import { Component, computed, inject } from '@angular/core';
import { RouterModule } from '@angular/router';

import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-user-nav',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './user-nav.component.html',
  styleUrl: './user-nav.component.scss'
})
export class UserNavComponent {
  private userService = inject(UserService);
  readonly isAdmin = this.userService.isAdmin;
  readonly isClientAdmin = computed(() => this.userService.hasClaim('client-admin'));
  readonly displayName = this.userService.select('displayName');
  readonly organizationName = this.userService.select('organizationName');
}
